<template>
  <div class="crm-prize-stage">
    <div>
      <p class="crm-prize-kicker">Instant gagnant</p>
      <h2 v-if="!won" class="crm-prize-title">Touchez la roue.</h2>
      <p v-if="!won" class="crm-hint">
        Nouveaux et comptes sans commande en cours. Comme un instant gagnant de salon.
      </p>

      <button
        type="button"
        class="crm-prize-wheel-btn"
        :class="{ 'is-won': !!won }"
        :disabled="spinning || drawing || !!won"
        :aria-busy="spinning ? 'true' : 'false'"
        :aria-label="won ? ('Remise ' + won + ' pour cent') : (spinning ? 'La roue tourne' : 'Tourner la roue')"
        @click="spin"
      >
        <div class="crm-prize-pointer" aria-hidden="true"></div>
        <svg
          class="crm-prize-svg"
          viewBox="0 0 200 200"
          :style="{ transform: 'rotate(' + rot + 'deg)' }"
        >
          <g v-for="(slice, i) in slices" :key="'s' + i">
            <path :d="slice.path" :fill="slice.color" />
            <text
              :x="slice.tx"
              :y="slice.ty"
              text-anchor="middle"
              dominant-baseline="middle"
              fill="#fffaf2"
              font-size="14"
              font-weight="800"
              :transform="'rotate(' + slice.mid + ' ' + slice.tx + ' ' + slice.ty + ')'"
            >{{ slice.label }}%</text>
          </g>
          <circle cx="100" cy="100" r="26" fill="#fffaf2" />
          <text
            x="100"
            y="106"
            text-anchor="middle"
            font-size="12"
            font-weight="800"
            fill="#1b2a4a"
          >{{ hubLabel }}</text>
        </svg>
      </button>

      <p v-if="spinning" class="crm-hint" style="margin-top:12px">La roue tourne…</p>
      <p v-if="msg" class="crm-hint danger" style="margin-top:8px">{{ msg }}</p>

      <div v-if="!won" class="crm-btn-stack" style="margin-top:14px">
        <button
          type="button"
          class="crm-btn crm-btn-primary crm-btn-lg"
          :disabled="spinning || drawing"
          @click="spin"
        >{{ spinning || drawing ? 'La roue tourne…' : 'Tourner la roue' }}</button>
        <button type="button" class="crm-btn crm-btn-outline" :disabled="spinning" @click="$emit('skip')">
          Passer la roue
        </button>
      </div>
    </div>

    <div v-if="won">
      <div class="crm-prize-card">
        <p class="crm-prize-card-kicker">Journées du Courtage</p>
        <p class="crm-prize-card-pct">−{{ won }}%</p>
        <p class="crm-prize-card-sub">sur la première commande Weedoit</p>
        <p class="crm-hint" style="margin:10px 0 0;color:#6b7280">Valable 30 jours · Salons</p>
      </div>
      <p class="crm-hint" style="margin-top:14px">
        Bravo. Envoyez la carte tout de suite sur WhatsApp.
      </p>
      <div class="crm-btn-stack" style="margin-top:12px">
        <a
          v-if="waLink"
          class="crm-btn crm-btn-ok crm-btn-lg"
          :href="waLink"
          target="_blank"
          rel="noopener"
          @click="$emit('sent', 'whatsapp')"
        >Envoyer sur WhatsApp</a>
        <a
          v-if="mailLink"
          class="crm-btn crm-btn-outline"
          :href="mailLink"
          @click="$emit('sent', 'email')"
        >Aussi par e-mail</a>
        <button type="button" class="crm-btn crm-btn-outline" @click="$emit('done')">Continuer</button>
      </div>
      <router-link
        class="crm-back"
        to="/crm-salon/conditions"
        style="display:inline-flex;margin-top:12px;color:#ff6500"
      >Conditions volume partenaires</router-link>
    </div>
  </div>
</template>

<script>
import {
  WHEEL_SLICES,
  WHEEL_COLORS,
  wheelTargetRotation,
  sliceIndexForPrize,
  prizeWhatsAppText,
  waHref,
  mailtoPrize
} from './crmSalonUtils'

function polar(cx, cy, r, a) {
  const rad = ((a - 90) * Math.PI) / 180
  return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)]
}

function slicePath(i, n, r, cx, cy) {
  const sweep = 360 / n
  const a0 = i * sweep
  const a1 = a0 + sweep
  const p0 = polar(cx, cy, r, a0)
  const p1 = polar(cx, cy, r, a1)
  return 'M ' + cx + ' ' + cy + ' L ' + p0[0] + ' ' + p0[1] + ' A ' + r + ' ' + r + ' 0 0 1 ' + p1[0] + ' ' + p1[1] + ' Z'
}

export default {
  name: 'CrmSalonPrizeWheel',
  props: {
    prospectId: { type: [String, Number], required: false, default: null },
    prenom: { type: String, default: '' },
    email: { type: String, default: '' },
    telephone: { type: String, default: '' },
    origin: { type: String, default: 'nouveau' }
  },
  data() {
    const n = WHEEL_SLICES.length
    const slices = WHEEL_SLICES.map((label, i) => {
      const sweep = 360 / n
      const mid = i * sweep + sweep / 2
      const t = polar(100, 100, 62, mid)
      return {
        label,
        color: WHEEL_COLORS[i % WHEEL_COLORS.length],
        path: slicePath(i, n, 96, 100, 100),
        mid,
        tx: t[0],
        ty: t[1]
      }
    })
    return {
      slices,
      rot: 0,
      spinning: false,
      drawing: false,
      won: null,
      prizeId: null,
      msg: '',
      timer: null
    }
  },
  computed: {
    waLink() {
      if (!this.won) return null
      return waHref(this.telephone, prizeWhatsAppText(this.prenom, this.won))
    },
    mailLink() {
      if (!this.won || !this.email) return null
      return mailtoPrize(this.email, this.prenom, this.won)
    },
    hubLabel() {
      if (this.won) return this.won + '%'
      if (this.spinning || this.drawing) return '…'
      return 'GO'
    }
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer)
  },
  methods: {
    async spin() {
      if (this.spinning || this.drawing || this.won) return
      this.msg = ''
      this.drawing = true
      try {
        const { data } = await this.$apollo.mutate({
          client: 'AUTH',
          mutation: require('src/graphql/auth/crmSalon/crmSalonDrawPrize.gql'),
          variables: {
            prospect_id: String(this.prospectId),
            origin: this.origin || 'nouveau'
          }
        })
        const r = data.crmSalonDrawPrize
        if (!r || !r.eligible) {
          this.msg = (r && r.message) || 'Tirage non disponible'
          this.drawing = false
          return
        }
        const prize = Number(r.prize_percent)
        if ([10, 15, 20, 25].indexOf(prize) === -1) {
          this.drawing = false
          this.msg = 'Tirage invalide'
          return
        }
        const sliceIndex = sliceIndexForPrize(prize)
        if (sliceIndex < 0) {
          this.drawing = false
          this.msg = 'Tirage invalide'
          return
        }
        // La part visée affiche déjà ce pourcentage : on le confirme avant le départ.
        this.slices[sliceIndex].label = prize
        this.prizeId = r.id
        this.drawing = false
        this.spinning = true
        this.rot = wheelTargetRotation(prize, this.rot, sliceIndex)
        const reduce = typeof window !== 'undefined' &&
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        const wait = reduce ? 80 : 4300
        this.timer = setTimeout(() => {
          this.won = prize
          this.spinning = false
          this.$emit('won', { prize, prizeId: this.prizeId })
        }, wait)
      } catch (e) {
        this.drawing = false
        this.spinning = false
        this.msg = (e && e.message) || 'Erreur tirage'
      }
    }
  }
}
</script>
